module.exports = __webpack_public_path__ + "img/sbb-night-east-2560x1600.269f699c.jpg";